import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=2420e036&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"
import style0 from "@/styles/_left_menu.scss?vue&type=style&index=0&id=2420e036&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2420e036",
  null
  
)

export default component.exports